// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3AZmD","text":"SelectPayment_text__1cmR5","title":"SelectPayment_title__KKf6P","btn":"SelectPayment_btn__SIiCT"};